<template>
  <div>
    <div class="serve-flex-col group_4" v-if="sort == 1">
      <div class="serve-flex-row serve-justify-center space-x-16">
        <span class="font_3">经济循环畅通改善</span>
        <span class="font_3">物流业支撑国民经济增长能力增强</span>
      </div>
      <div class="serve-flex-row serve-justify-center group_5">
        <span class="font_4 text_10">发布时间：2023年07月30日19:59</span>
        <span class="font_4 text_11">来源： 央视网</span>
      </div>
      <div class="serve-flex-col group_6">
        <span class="serve-self-start font_2 text_12">
          央视网消息：中国物流与采购联合会公布：今年上半年，全国社会物流总额为160.6万亿元，同比增长4.8%，物流需求整体呈现持续回升态势。
        </span>
        <span class="serve-self-start font_2 text_13"
          >物流需求升级动力明显</span
        >
        <span class="font_2 text_14">
          从物流需求结构来看，工业品物流、农产品物流增速总体平稳，为社会物流总额恢复提供了有力支撑。具体来看，上半年工业生产持续恢复，工业品物流总额同比增长3.8%，较1—5月份加快0.2个百分点。工业品物流整体回稳的态势较为稳固。从结构来看，新动能不断积聚，创新发展动能成为重要增长动力。上半年，装备制造业物流总额同比增长6.5%，高技术制造带动物流需求增长的引擎作用继续显现。从民生消费领域来看，上半年单位与居民物品物流总额同比增长10%。尤其是二季度以来各类消费场景持续恢复，相关物流需求呈现较快增长。线上线下消费物流同步回升，二季度全国实物商品网上零售额同比增长10.8%，增速比一季度加快3.5个百分点，上半年实现快递业务量超过600亿件；便利店、百货店等线下物流额增速均超过8%，零售、餐饮消费物流持续恢复。另外，上半年进口物流总额8.6万亿元，同比增长13.8%。我国进口实物物流规模整体稳中有升，展现了较强的韧性。
          <br />
        </span>
        <span class="serve-self-start font_2">　　物流运行成本稳中有降</span>
        <span class="font_2 text_15">
          　　上半年，物流保畅通、降成本相关政策效果落地显效，经济循环畅通有所改善，物流运行成本整体有所回落。上半年，社会物流总费用8.6万亿元，同比增长3.7%；社会物流总费用与GDP的比率为14.5%，比去年上半年回落0.3个百分点。单位GDP所需物流费用有所下降，显示物流运行效率有所提升。
          从物流总费用的构成变化来看，运输费用占比同比提高0.6个百分点，保管费用和管理费用占比分别下降0.5和0.1个百分点。显示当前物流运行逐步由静转动，生产、流通、消费等经济循环逐步畅通。
          从物流数据来看，物流仓储周转速度加快，库存水平持续回落，库存周转效率指数二季度以来均保持在扩张区间，并且环比持续回升。同时，库存指数位于50%以下，环比持续回落。综合来看，经济循环整体趋于改善，仓储周转效率提升，尤其是消费、升级领域流通周转加快，库存水平较低，而部分传统制造领域库存依然较高。
          <br />
        </span>
        <span class="serve-self-start font_2 text_16"
          >有利条件较多 下半年我国物流需求有望继续扩大</span
        >
        <span class="font_2 text_17">
          专家表示，综合来看，支撑物流稳定恢复的有利条件依然较多。随着下半年国家进一步扩大内需，提振汽车、电子产品、家居等领域，鼓励促进民营经济发展，建设现代化产业体系，加强民生保障，同时，结合物流产业具有巨大的潜力和良好的韧性，社会物流需求长期向好的趋势将更明显。中国物流与采购联合会副会长
          蔡进：从目前来看，增量的需求也在进一步形成中，从我们物流的运行中间能够很明显地看到这一点。比如说像进口、像居民与单位的这种物流需求，都是在不断形成增量需求的这么一个过程中间。从下半年来看，消费的需求还会有一个比较好的增长。
          <br />
        </span>
        <span class="serve-self-start font_2 text_18"
          >政策协同发力 激发市场主体活力</span
        >
        <span class="font_2 text_19">
          上半年，支持物流发展的相关政策协同发力，减税、降成本、助企纾困效果不断显现，在提振物流需求的同时改善物流企业营商环境，也激发了市场主体活力。国家层面，今年以来，促进物流发展的利好政策不断出台。国家发展改革委等多部门联合发布《关于做好2023年降成本重点工作的通知》，提出了推进物流提质增效降本等8个方面22项重点任务以及系列相关政策，着力推动完善现代物流体系、落实物流多项税费减免延期、促进运输结构调整优化、助力打通“最后一公里”、实现交通物流提质增效。
          <br />
        </span>
        <span class="serve-self-start font_2 text_20">
          中国物流与采购联合会副会长
          蔡进：从宏观环境来讲，今年以来整个物流的营商环境得到了比较明显的改善，物流业支撑国民经济恢复增长的能力在进一步增强。
        </span>
      </div>
      <div class="serve-flex-row group_7 space-x-12">
        <img
          class="serve-flex-auto image_2"
          src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16922556527387062909.png"
        />
        <img
          class="serve-shrink-0 image_3"
          src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16922556527428164558.png"
        />
      </div>
    </div
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      sort:1
    };
  },
};
</script> 

<style scoped>
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 256px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.serve-flex-row {
  display: flex;
  flex-direction: row;
}

.serve-flex-col {
  display: flex;
  flex-direction: column;
}

.serve-justify-start {
  justify-content: flex-start;
}

.serve-justify-end {
  justify-content: flex-end;
}

.serve-justify-center {
  justify-content: center;
}

.serve-justify-between {
  justify-content: space-between;
}

.serve-justify-around {
  justify-content: space-around;
}

.serve-justify-evenly {
  justify-content: space-evenly;
}

.serve-items-start {
  align-items: flex-start;
}

.serve-items-end {
  align-items: flex-end;
}

.serve-items-center {
  align-items: center;
}

.serve-items-baseline {
  align-items: baseline;
}

.serve-items-stretch {
  align-items: stretch;
}

.serve-self-start {
  align-self: flex-start;
}

.serve-self-end {
  align-self: flex-end;
}

.serve-self-center {
  align-self: center;
}

.serve-self-baseline {
  align-self: baseline;
}

.serve-self-stretch {
  align-self: stretch;
}

.serve-flex-1 {
  flex: 1 1 0%;
}

.serve-flex-auto {
  flex: 1 1 auto;
}

.serve-grow {
  flex-grow: 1;
}

.serve-grow-0 {
  flex-grow: 0;
}

.serve-shrink {
  flex-shrink: 1;
}

.serve-shrink-0 {
  flex-shrink: 0;
}

.serve-relative {
  position: relative;
}
.section_2 {
  padding: 0.67rem 1.25rem 0.83rem;
  background-image: url("../assets/images/4.png");
  margin-bottom: 0.4rem;
}
.space-y-68 > *:not(:first-child) {
  margin-top: 0.27rem;
}
.text_8 {
  color: #ffffff;
  font-size: 0.23rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.22rem;
}
.text_9 {
  color: #ffffff;
  font-size: 0.1rem;
  font-family: PingFang;
  line-height: 0.1rem;
}

.image_2 {
  width: 2.61rem;
  height: 1.18rem;
}

.image_3 {
  margin-right: 0.031rem;
  width: 2.35rem;
  height: 1.18rem;
}

.font_2 {
  font-size: 0.063rem;
  font-family: PingFang;
  line-height: 0.14rem;
  color: #000000;
}
.group_4 {
  padding-left: 1.25rem;
  padding-right: 1.22rem;
}
.space-x-16 > *:not(:first-child) {
  margin-left: 0.063rem;
}
.font_3 {
  font-size: 0.13rem;
  font-family: PingFang;
  line-height: 0.12rem;
  font-weight: 700;
  color: #383838;
}
.group_5 {
  margin-top: 0.2rem;
}
.font_4 {
  font-size: 0.055rem;
  font-family: SourceHanSansCN;
  line-height: 0.055rem;
  color: #383838;
}
.text_10 {
  line-height: 0.051rem;
}
.text_11 {
  line-height: 0.051rem;
}
.group_6 {
  margin-top: 0.25rem;
}
.text_12 {
  margin-left: 0.13rem;
}
.text_13 {
  margin-left: 0.13rem;
}
.text_14 {
  text-align: justify;
  text-indent: 0.13rem;
}
.text_15 {
  text-align: justify;
}
.text_16 {
  margin-left: 0.13rem;
}
.text_17 {
  text-align: justify;
  text-indent: 0.13rem;
}
.text_18 {
  margin-left: 0.13rem;
}
.text_19 {
  text-align: justify;
  text-indent: 0.11rem;
}
.text_20 {
  margin-left: 0.11rem;
  margin-top: -0.023rem;
}
.group_7 {
  margin-top: 0.39rem;
}
.space-x-12 > *:not(:first-child) {
  margin-left: 0.047rem;
}
.image_2 {
  width: 2.61rem;
  height: 1.18rem;
}
.image_3 {
  margin-right: 0.031rem;
  width: 2.35rem;
  height: 1.18rem;
}
</style>



// WEBPACK FOOTER //
// src/views/new1.vue